import script from "./CampaignsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./CampaignsTable.vue?vue&type=script&setup=true&lang=js"

import "./CampaignsTable.vue?vue&type=style&index=0&id=3f82df67&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f82df67"]])

export default __exports__